import { render, staticRenderFns } from "./UserSetPasswordDialog.vue?vue&type=template&id=9b8639ba&scoped=true"
import script from "./UserSetPasswordDialog.vue?vue&type=script&lang=ts"
export * from "./UserSetPasswordDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8639ba",
  null
  
)

export default component.exports